import { Satzart } from '@/types/Satzart';
import { Vue } from 'vue-property-decorator';
import Impfung from '@/types/Impfung';
import PatUntersuchung from '@/types/PatUntersuchung';
import PatBrief from '@/types/PatBrief';
import PatRezept from '@/types/PatRezept';
import PatDiagnose from '@/types/PatDiagnose';
import PatAnamnese from '@/types/PatAnamnese';
import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';
import store from '@/store';

export default class Karteieintrag extends Impfung {
    public get display(): { [satzart: number]: (eintrag: Karteieintrag) => string | null } {
        const getSystemEinstellung: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T> =
            store.getters['authentication/getSystemEinstellung'];
        return {
            [Satzart.Plan]: (eintrag: Karteieintrag): string | null => {
                return eintrag.reiseziele || eintrag.reiseziel || eintrag.reiseart || eintrag.text || 'Plan';
            },
            [Satzart.Impfung]: (eintrag: Karteieintrag): string | null => {
                return eintrag.teilimpfungsKuerzel + eintrag.impfungsText;
            },
            [Satzart.Leistung]: (eintrag: Karteieintrag): string | null => eintrag.leistung_bezeichnung,
            [Satzart.Diagnose]: (eintrag: Karteieintrag): string | null => eintrag.patdiagnose_diagnose,
            [Satzart.Anamnese]: (eintrag: Karteieintrag): string | null => 'Anamnese',
            [Satzart.Text]: (eintrag: Karteieintrag): string | null => eintrag.text,
            [Satzart.Untersuchung]: (eintrag: Karteieintrag): string | null => {

                if (getSystemEinstellung('muw').isEnabled()) {
                        return [
                            eintrag.untersuchung?.untersuchung,
                            eintrag.untersuchung?.befundergebnisVariiert,
                        ].filter(value => value).join('; Befund: ');
                } else {
                    return [
                        eintrag.untersuchung?.untersuchung,
                        eintrag.untersuchung?.befundergebnis,
                    ].filter(value => value).join('; Befund: ');
                }

                //return eintrag?.untersuchung?.untersuchung ?? '';
            },
            [Satzart.Brief]: (eintrag: Karteieintrag): string | null => eintrag.brief?.briefart_art ?? '',
            [Satzart.Rezept]: (eintrag: Karteieintrag): string => eintrag.rezept?.bezeichnung ?? '',
        };
    }

    public get impfungsText(): string {
        if (this.impfstoff_id || this.isElgaImpfung) {
            return this.isElgaImpfung
                ? this.elga_displayname ?? ''
                : `${this.impfstoff_impfung} (${this.bezeichnung})`;
        }

        if (this.impfung) {
            if (this.impfstoff) {
                return `${this.impfung} (${this.impfstoff})`;
            }

            return this.impfung;
        }

        return '';
    }

    public get teilimpfungsKuerzel(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'A. ';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. ';
            }
        }

        return '';
    }

    public get teilimpfungsText(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'Auffrischung';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. Teilimpfung';
            }
        }

        return '';
    }

    public get textDisplay(): string {
        return this.satzart !== null ? this.display[this.satzart](this) ?? '' : '';
    }

    public get arztDisplay(): string | null {
        if (this.satzart === 10) {
            return this.plan_arzt;
        }
        return this.aerzte_arzt;
    }

    public get impfdatumDisplay(): string {
        return Vue.prototype.$d(this.impfdatum);
    }

    public get impfstelleDisplay(): string {
        return this.impfstelle_abkuerzung ?? this.impfstelle_bezeichnung ?? '';
    }

    constructor(data?: Partial<Karteieintrag>) {
        super(data);
        Object.assign(this, data);

        switch (this.satzart) {
            case Satzart.Untersuchung:
                this.untersuchung = new PatUntersuchung(this.untersuchung);
                break;
            case Satzart.Brief:
                this.brief = new PatBrief(this.brief);
                break;
            case Satzart.Rezept:
                this.rezept = new PatRezept(this.rezept);
                break;
            case Satzart.Diagnose:
                this.diagnose = new PatDiagnose(this.diagnose);
                break;
            case Satzart.Anamnese:
                this.anamnese = new PatAnamnese(this.anamnese);
                break;
        }
    }
}
